<template>
	<a-select v-if="loaded" :value="selectValue" :size="inputSize" mode="multiple" label-in-value :placeholder="placeholder" :filter-option="false" :not-found-content="null" show-search :loading="loading" option-label-prop="name" class="mr-sm-4 w-100" @search="tagSearch($event)" @focus="tagSearch($event, true)" @change="setTags($event)">
		<a-select-option v-for="t in tags" :key="t.id" :value="t.id" :name="t.name" :title="parser().tag(t.type).text">
			<div class="d-flex justify-content-between w-100">
				<span class="mr-auto">{{ t.name }}</span>
				<a-tag :color="parser().tag(t.type).color" class="ml-2 mr-0">
					{{ parser().tag(t.type).text }}
				</a-tag>
			</div>
		</a-select-option>
	</a-select>
</template>

<script>
import _ from 'lodash';

export default {
	name: 'TagSelect',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		placeholder: {
			type: String,
			default: 'Seleccionar tags...',
		},
		limit: {
			type: Number,
			default: null,
		},
		type: {
			type: String,
			default: null,
		},
	},
	emits: ['input'],
	data() {
		return {
			tags: [],
			loading: false,
			loaded: false,
			firstLoad: true,
		};
	},
	computed: {
		inputSize() {
			return this.$store.getters.settings.inputSize;
		},
		selectValue() {
			const vals = [];
			if (typeof this.value === 'object' && this.value !== null) {
				this.value.forEach((t) => {
					// if (!t.name && t.label) t.name = t.label;
					if (!t.key && t.id) t.key = t.id;

					vals.push({ ...t });
				});
			}

			return vals;
		},
	},
	watch: {
		value(val) {
			// if (!val) val = [];
			// if (!oldVal) oldVal = [];

			// if (JSON.stringify(val.map(d => d.id)) !== JSON.stringify(oldVal.map(d => d.id))) {
			// 	const parsedValue = this.parse(val.map((v) => {
			// 		if (v.key === undefined) return v;

			// 		const tag = oldVal.find(ov => v.key === ov.id);

			// 		return tag || v;
			// 	}));

			// 	this.$emit('input', parsedValue);

			if (this.firstLoad && this.loaded) {
				if (val !== null && val.length) {
					this.tags = val || [];
				}
			}
			// }
			// this.$emit('input', val);
		},
	},
	created() {
		// if (typeof this.value === 'object' && this.value !== null) {
		// const parsedValue = this.parse(this.value);
		// console.log('craeted this.value', (this.value || []).map(d => ({ ...d })));
		// if (this.firstLoad && this.loaded) this.tags = this.value || [];
		// this.$emit('input', parsedValue);
		// this.tags = this.value;
		// }
	},
	mounted() {
		// console.log('mounted this.value', (this.value || []).map(d => ({ ...d })));
		if (this.tags.length === 0 && this.value !== null) this.tags = this.value || [];
		this.loaded = true;
	},
	methods: {
		tagSearch: _.debounce(async function (value, focus = false) {
			if (focus && this.firstLoad) this.tags = [];

			if (!focus || (focus && this.tags.length === 0)) {
				this.loading = true;
				this.tags = [];
				try {
					const tags = await this.$sdk.tags().list({ search: value, order_by: 'popularity', type: this.type });
					if (this.firstLoad) this.firstLoad = false;
					if (tags.ok) this.tags = tags.data.results;
				} catch (e) { /* silent */ } finally {
					this.loading = false;
				}
			}
		}, 300),
		parse(val) {
			const vals = [];

			if (val !== null) {
				val.forEach((t) => {
					if (t.key !== undefined) {
						vals.push(t);
					} else if (t.id !== undefined) {
						vals.push({
							key: t.id,
							label: t.name,
							type: t.type,
							id: t.id,
						});
					}
				});
			}

			return vals;
		},
		setTags(selectedTags) {
			// console.log(selectedTags)
			// console.log('setTags selectedTags', selectedTags.map(d => ({ ...d })));

			const newTags = [];

			if (this.limit !== null && selectedTags.length > this.limit) selectedTags.shift();

			if (selectedTags.length > 0) {
				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < selectedTags.length; i++) {
					// Busca primero la tag seleccionada en las tags buscadas, sino entonces busca en la ya seleccionadas.
					// Esto es para conservar las propiedades. El componente usa solo { key, label }. Entonces se cambia esto a { key, label, name, type, id }
					const newTag = this.tags.find(d => d.id === selectedTags[i].key) || this.value.find(d => d.id === selectedTags[i].key);

					if (newTag) {
						newTags.push({
							key: newTag.id,
							label: newTag.name,
							name: newTag.name,
							type: newTag.type,
							id: newTag.id,
						});
					}
				}
			}

			this.$emit('input', newTags);
		},
	},
};
</script>

<style lang="scss">
	.ant-select-selection__choice[title="Tienda"],
	.ant-select-selection__choice[title="Grupo"],
	.ant-select-selection__choice[title="Categoría"],
	.ant-select-selection__choice[title="Hashtag"],
	.ant-select-selection__choice[title="Marca"] {
		color: #fff !important;
		border: 0 !important;
	}

	.ant-select-selection__choice[title="Tienda"] .ant-select-selection__choice__remove,
	.ant-select-selection__choice[title="Grupo"] .ant-select-selection__choice__remove,
	.ant-select-selection__choice[title="Categoría"] .ant-select-selection__choice__remove,
	.ant-select-selection__choice[title="Hashtag"] .ant-select-selection__choice__remove,
	.ant-select-selection__choice[title="Marca"] .ant-select-selection__choice__remove {
		color: #fff !important;
	}

	.ant-select-selection__choice[title="Tienda"] {
		background-color: rgb(242, 19, 93) !important;
	}
	.ant-select-selection__choice[title="Grupo"] {
		background-color: rgb(255, 130, 0) !important;
	}
	.ant-select-selection__choice[title="Categoría"] {
		background-color: rgb(23, 201, 100) !important;
	}
	.ant-select-selection__choice[title="Hashtag"] {
		background-color: rgb(106, 122, 132) !important;
	}
	.ant-select-selection__choice[title="Marca"] {
		background-color: rgb(27, 85, 227) !important;
	}
</style>
